/** 侧栏是否展示「酒店管理 → 酒店列表」（具备时才视为有酒店模块菜单权限） */
function hasHotelListMenu(routers) {
  const list = Array.isArray(routers) ? routers : []
  const hms = list.find(r => r && r.name === 'hms')
  if (!hms || !Array.isArray(hms.children) || !hms.children.length) {
    return false
  }
  return hms.children.some(c => c && !c.hidden && c.name === 'hotel')
}

function stateHasHotelResource(state) {
  const urls = state.user.resourceUrls
  if (!Array.isArray(urls)) return false
  return urls.some(u => {
    if (u == null || typeof u !== 'string') return false
    const s = u.trim()
    return s === '/hotel/**' || s === '/hotel' || s.startsWith('/hotel/')
  })
}

const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  paymentApplyPendingCount: state => state.app.paymentApplyPendingCount,
  apPendingCount: state => state.app.apPendingCount,
  holdCancellationTodayCount: state => state.app.holdCancellationTodayCount,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  nickName: state => state.user.nickName,
  roles: state => state.user.roles,
  adminId: state => state.user.adminId,
  resourceUrls: state => state.user.resourceUrls || [],
  /**
   * 是否拥有「订单删除」资源（ums_resource.url 一般为 /order/delete/**）。
   * 与角色管理里订单模块勾选「订单删除」一致；保存分配后需 GetInfo 或整页刷新以更新。
   */
  hasOrderDeleteResource: state => {
    const urls = state.user.resourceUrls
    if (!Array.isArray(urls)) return false
    return urls.some(u => {
      if (u == null || typeof u !== 'string') return false
      const s = u.trim()
      return s === '/order/delete/**' || s === '/order/delete' || s.startsWith('/order/delete/')
    })
  },
  /** 是否拥有订单 API 资源（ums_resource.url 一般为 /order/**），与 DynamicAuthorizationManager 一致 */
  hasOrderResource: state => {
    const urls = state.user.resourceUrls
    if (!Array.isArray(urls)) return false
    return urls.some(u => {
      if (u == null || typeof u !== 'string') return false
      const s = u.trim()
      return s === '/order/**' || s === '/order' || s.startsWith('/order/')
    })
  },
  /** 是否拥有财务 API 资源（ums_resource.url 一般为 /fin/**），与 DynamicAuthorizationManager 一致 */
  hasFinResource: state => {
    const urls = state.user.resourceUrls
    if (!Array.isArray(urls)) return false
    return urls.some(u => {
      if (u == null || typeof u !== 'string') return false
      const s = u.trim()
      return s === '/fin/**' || s === '/fin' || s.startsWith('/fin/')
    })
  },
  /** 是否拥有酒店管理 API 资源（ums_resource.url 一般为 /hotel/**） */
  hasHotelResource: state => stateHasHotelResource(state),
  /**
   * 是否具备酒店模块权限：侧栏有「酒店列表」菜单且分配了 /hotel/** 资源（与侧栏财务角标「菜单+资源」口径一致）。
   */
  hasHotelModuleAccess: (state, getters) => hasHotelListMenu(getters.routers) && stateHasHotelResource(state),
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js